module.exports = __webpack_public_path__ + "img/nkp_logo_en.9edf15fc.png";